"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryWriteOffInfoRequest = void 0;
var QueryWriteOffInfoRequest = /** @class */ (function () {
    function QueryWriteOffInfoRequest() {
    }
    return QueryWriteOffInfoRequest;
}());
exports.QueryWriteOffInfoRequest = QueryWriteOffInfoRequest;
//# sourceMappingURL=queryWriteOffInfo.request.js.map